<template>
  <div class="g-first">
    <!-- 查询条件区域开始 -->
    <div
      class="g-search-wrap g-clear-float"
      ref="searchWrap"
    >
      <!-- 功能按钮区域开始 -->
      <div class="g-toolbar-wrap">
        <slot name="toolbar"></slot>
      </div>
      <!-- 功能按钮区域结束 -->
      <el-form
        :inline="true"
        :model="params"
        :rules="paramsRules"
      >
        <slot name="search"></slot>
        <el-form-item
          label=""
          v-if="searchBtnShow"
        >
          <el-button
            type="primary"
            size="small"
            @click="search"
          >搜索</el-button>
          <el-button
            size="small"
            @click="clear"
          >清空</el-button>
        </el-form-item>
      </el-form>
      <slot name="other"></slot>
    </div>
    <!-- 查询条件区域结束 -->

    <!-- 表格区域开始 -->
    <div
      class="g-table-wrap"
      :style="{top: tableTop + 'px'}"
    >
      <el-table
        :data="data"
        height="100%"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
        >

        </el-table-column>
        <template v-for="item in tableColumn">
          <el-table-column
            :prop="item.prop"
            :label="item.label"
            show-overflow-tooltip
            :width="item.width"
          >
            <template slot-scope="scope">
              <slot
                v-if="item.slotName"
                :name="item.slotName"
                :data="scope"
              ></slot>
              <span v-else>{{scope.row[item.prop]}}</span>
            </template>

          </el-table-column>
        </template>

        <slot name="operation"></slot>
      </el-table>
    </div>
    <!-- 表格区域结束 -->

    <!-- 分页区域开始 -->
    <div class="g-page-wrap">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="params.current"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="params.size"
      >
      </el-pagination>
    </div>
    <!-- 分页区域结束 -->
  </div>
</template>
<script>
export default {
  name: "list-page",
  props: {
    searchBtnShow: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    params: {
      type: Object,
      default() {
        return {};
      },
    },
    paramsRules: {
      type: Object,
      default() {
        return {};
      },
    },
    total: {
      type: Number,
      default: 0,
    },
    tableColumn: Array
  },
  data() {
    return {
      tableTop: 0,
    };
  },
  mounted() {
    this.initTableTop();
  },
  methods: {
    initTableTop() {
      this.$nextTick(() => {
        this.tableTop = this.$refs.searchWrap?this.$refs.searchWrap.offsetHeight:''
      });
    },
    handleSizeChange(val) {
      this.$parent.params.size = val;
      this.handleCurrentChange(1)
    },
    handleCurrentChange(val) {
      this.$parent.params.current = val;
      this.$parent.getData()
    },
    search() {
      this.$parent.params.current = 1;
      this.$parent.getData();
      this.$emit('search-click')
    },
    clear() {
      for (let key in this.$parent.params) {
        if (key !== "current" && key !== "size") {
          this.$parent.params[key] = "";
        }
      }
      this.$emit('params-clear')
    },
  },
};
</script>
<style lang="stylus" scoped></style>


// WEBPACK FOOTER //
// src/components/list-page/index.vue